// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"347":"5b14e97b","652":"6177d04d"}[chunkId] + ".js";
};